import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, changedRecord, filter }) =>
    present(
      repository
        .reloadProjectTimeSheet(project, changedRecord, filter)
        .then((timeSheet) => ({ project, changedRecord, timeSheet, filter }))
        .catch(() => Promise.reject({ project, changedRecord, filter })),
    );
}

export type { Interactor };

export { createInteractor };
